
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTransformDiagonal as ObiTransformDiagonalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-transform-diagonal.js';
 
 
 

 
 export const ObiTransformDiagonal = createComponent({
   react: React,
   tagName: 'obi-transform-diagonal',
   elementClass: ObiTransformDiagonalElement,
   events: {
     
   }
  });
 
 